export default {
  list: [],
  whatsappLink: null,
  whatsappMessage: null,
  whatsappProductMessage: null,
};
